import '../css/boutchou.css';

export default function Boutchou() {
    return (
        <div className="boutouchou-container">
            <h1>Côté jardin 🏰🎈🏐</h1>
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "flex-start", verticalAlign: "center", gap: "20px" }}>
                <img width='300' src="images/cotejardin2.jpg" alt="Nina et le papillon" className="info-photo" />
                <img width='300' src="images/cotejardin.jpg" alt="Sam & Nina dans le jardin" className="info-photo" />
                <img width='300' src="images/cotejardin3.jpg" alt="Sam et le papillon" className="info-photo" />
            </div>

            <h2>Nous proposons :</h2>
            <ul className="activities-list">
                <li>🏰🎈Chateau gonflable</li>
                <li>🏐Jeux à disposition</li>
            </ul>

            <p>Les petits-bouts pourront s'amuser dans le château gonflable. Chaque enfant est sous la vigilence de son/ses parent(s).</p>
            <p>Apportez votre lit pliant, un coin dodo est prévu pour les petits-bouts qui ne tiendraient pas jusqu'au bout de la nuit.</p>

        </div>
    );
}

